
      import { createLanguage, createTranslationFile } from '@vocab/webpack/web';
      
    const translations = createTranslationFile({
      "en": createLanguage(
        require.resolveWeak("./translations.json-en-virtual.json!=!../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJNaW4gY2hhcmFjdGVycyBvciBsZXNzIjoie21pbn0gY2hhcmFjdGVycyBvciBtb3JlIn0%3D!"),
        () => import(
          /* webpackChunkName: "en-translations" */
          "./translations.json-en-virtual.json!=!../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJNaW4gY2hhcmFjdGVycyBvciBsZXNzIjoie21pbn0gY2hhcmFjdGVycyBvciBtb3JlIn0%3D!"
        )
      ),
"th": createLanguage(
        require.resolveWeak("./translations.json-th-virtual.json!=!../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJNaW4gY2hhcmFjdGVycyBvciBsZXNzIjoie21pbn0g4LiV4Lix4Lin4Lit4Lix4LiB4Lip4Lij4Lir4Lij4Li34Lit4Lih4Liy4LiB4LiB4Lin4LmI4LiyIn0%3D!"),
        () => import(
          /* webpackChunkName: "th-translations" */
          "./translations.json-th-virtual.json!=!../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJNaW4gY2hhcmFjdGVycyBvciBsZXNzIjoie21pbn0g4LiV4Lix4Lin4Lit4Lix4LiB4Lip4Lij4Lir4Lij4Li34Lit4Lih4Liy4LiB4LiB4Lin4LmI4LiyIn0%3D!"
        )
      ),
"id": createLanguage(
        require.resolveWeak("./translations.json-id-virtual.json!=!../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJNaW4gY2hhcmFjdGVycyBvciBsZXNzIjoie21pbn0ga2FyYWt0ZXIgYXRhdSBsZWJpaCJ9!"),
        () => import(
          /* webpackChunkName: "id-translations" */
          "./translations.json-id-virtual.json!=!../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJNaW4gY2hhcmFjdGVycyBvciBsZXNzIjoie21pbn0ga2FyYWt0ZXIgYXRhdSBsZWJpaCJ9!"
        )
      ),
"en-AU": createLanguage(
        require.resolveWeak("./translations.json-en-AU-virtual.json!=!../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJNaW4gY2hhcmFjdGVycyBvciBsZXNzIjoie21pbn0gY2hhcmFjdGVycyBvciBtb3JlIn0%3D!"),
        () => import(
          /* webpackChunkName: "en-AU-translations" */
          "./translations.json-en-AU-virtual.json!=!../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJNaW4gY2hhcmFjdGVycyBvciBsZXNzIjoie21pbn0gY2hhcmFjdGVycyBvciBtb3JlIn0%3D!"
        )
      ),
"en-HK": createLanguage(
        require.resolveWeak("./translations.json-en-HK-virtual.json!=!../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJNaW4gY2hhcmFjdGVycyBvciBsZXNzIjoie21pbn0gY2hhcmFjdGVycyBvciBtb3JlIn0%3D!"),
        () => import(
          /* webpackChunkName: "en-HK-translations" */
          "./translations.json-en-HK-virtual.json!=!../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJNaW4gY2hhcmFjdGVycyBvciBsZXNzIjoie21pbn0gY2hhcmFjdGVycyBvciBtb3JlIn0%3D!"
        )
      ),
"en-ID": createLanguage(
        require.resolveWeak("./translations.json-en-ID-virtual.json!=!../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJNaW4gY2hhcmFjdGVycyBvciBsZXNzIjoie21pbn0gY2hhcmFjdGVycyBvciBtb3JlIn0%3D!"),
        () => import(
          /* webpackChunkName: "en-ID-translations" */
          "./translations.json-en-ID-virtual.json!=!../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJNaW4gY2hhcmFjdGVycyBvciBsZXNzIjoie21pbn0gY2hhcmFjdGVycyBvciBtb3JlIn0%3D!"
        )
      ),
"en-MY": createLanguage(
        require.resolveWeak("./translations.json-en-MY-virtual.json!=!../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJNaW4gY2hhcmFjdGVycyBvciBsZXNzIjoie21pbn0gY2hhcmFjdGVycyBvciBtb3JlIn0%3D!"),
        () => import(
          /* webpackChunkName: "en-MY-translations" */
          "./translations.json-en-MY-virtual.json!=!../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJNaW4gY2hhcmFjdGVycyBvciBsZXNzIjoie21pbn0gY2hhcmFjdGVycyBvciBtb3JlIn0%3D!"
        )
      ),
"en-NZ": createLanguage(
        require.resolveWeak("./translations.json-en-NZ-virtual.json!=!../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJNaW4gY2hhcmFjdGVycyBvciBsZXNzIjoie21pbn0gY2hhcmFjdGVycyBvciBtb3JlIn0%3D!"),
        () => import(
          /* webpackChunkName: "en-NZ-translations" */
          "./translations.json-en-NZ-virtual.json!=!../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJNaW4gY2hhcmFjdGVycyBvciBsZXNzIjoie21pbn0gY2hhcmFjdGVycyBvciBtb3JlIn0%3D!"
        )
      ),
"en-PH": createLanguage(
        require.resolveWeak("./translations.json-en-PH-virtual.json!=!../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJNaW4gY2hhcmFjdGVycyBvciBsZXNzIjoie21pbn0gY2hhcmFjdGVycyBvciBtb3JlIn0%3D!"),
        () => import(
          /* webpackChunkName: "en-PH-translations" */
          "./translations.json-en-PH-virtual.json!=!../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJNaW4gY2hhcmFjdGVycyBvciBsZXNzIjoie21pbn0gY2hhcmFjdGVycyBvciBtb3JlIn0%3D!"
        )
      ),
"en-SG": createLanguage(
        require.resolveWeak("./translations.json-en-SG-virtual.json!=!../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJNaW4gY2hhcmFjdGVycyBvciBsZXNzIjoie21pbn0gY2hhcmFjdGVycyBvciBtb3JlIn0%3D!"),
        () => import(
          /* webpackChunkName: "en-SG-translations" */
          "./translations.json-en-SG-virtual.json!=!../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJNaW4gY2hhcmFjdGVycyBvciBsZXNzIjoie21pbn0gY2hhcmFjdGVycyBvciBtb3JlIn0%3D!"
        )
      ),
"en-TH": createLanguage(
        require.resolveWeak("./translations.json-en-TH-virtual.json!=!../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJNaW4gY2hhcmFjdGVycyBvciBsZXNzIjoie21pbn0gY2hhcmFjdGVycyBvciBtb3JlIn0%3D!"),
        () => import(
          /* webpackChunkName: "en-TH-translations" */
          "./translations.json-en-TH-virtual.json!=!../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJNaW4gY2hhcmFjdGVycyBvciBsZXNzIjoie21pbn0gY2hhcmFjdGVycyBvciBtb3JlIn0%3D!"
        )
      ),
"th-TH": createLanguage(
        require.resolveWeak("./translations.json-th-TH-virtual.json!=!../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJNaW4gY2hhcmFjdGVycyBvciBsZXNzIjoie21pbn0g4LiV4Lix4Lin4Lit4Lix4LiB4Lip4Lij4Lir4Lij4Li34Lit4Lih4Liy4LiB4LiB4Lin4LmI4LiyIn0%3D!"),
        () => import(
          /* webpackChunkName: "th-TH-translations" */
          "./translations.json-th-TH-virtual.json!=!../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJNaW4gY2hhcmFjdGVycyBvciBsZXNzIjoie21pbn0g4LiV4Lix4Lin4Lit4Lix4LiB4Lip4Lij4Lir4Lij4Li34Lit4Lih4Liy4LiB4LiB4Lin4LmI4LiyIn0%3D!"
        )
      ),
"id-ID": createLanguage(
        require.resolveWeak("./translations.json-id-ID-virtual.json!=!../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJNaW4gY2hhcmFjdGVycyBvciBsZXNzIjoie21pbn0ga2FyYWt0ZXIgYXRhdSBsZWJpaCJ9!"),
        () => import(
          /* webpackChunkName: "id-ID-translations" */
          "./translations.json-id-ID-virtual.json!=!../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJNaW4gY2hhcmFjdGVycyBvciBsZXNzIjoie21pbn0ga2FyYWt0ZXIgYXRhdSBsZWJpaCJ9!"
        )
      ),
"en-PSEUDO": createLanguage(
        require.resolveWeak("./translations.json-en-PSEUDO-virtual.json!=!../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJNaW4gY2hhcmFjdGVycyBvciBsZXNzIjoiW3ttaW59IMOn4bipxIPEg8SDxZnEg8SDxIPDp%2BG5r%2BG6veG6veG6vcWZxaEgw7bDtsO2xZkgbcyCw7bDtsO2xZnhur3hur3hur1dIn0%3D!"),
        () => import(
          /* webpackChunkName: "en-PSEUDO-translations" */
          "./translations.json-en-PSEUDO-virtual.json!=!../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJNaW4gY2hhcmFjdGVycyBvciBsZXNzIjoiW3ttaW59IMOn4bipxIPEg8SDxZnEg8SDxIPDp%2BG5r%2BG6veG6veG6vcWZxaEgw7bDtsO2xZkgbcyCw7bDtsO2xZnhur3hur3hur1dIn0%3D!"
        )
      )
      });
  
      export { translations as default };
    